var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"lyf-ui-text",class:[_vm.family]},[(_vm.unit)?_c('b',[_vm._v(_vm._s(_vm.unit))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }